import { useRouter } from 'next/router'

import { Pagination as KinerjaPagination } from 'app/KinerjaShared/components/Pagination'
import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

type PaginationProps = {
  className?: string
  paramKey: string
  itemLabel?: string
}

export function Pagination({
  className,
  paramKey,
  itemLabel = 'pegawai',
}: PaginationProps) {
  const router = useRouter()

  const { filteredItems, pageSize, currentPage, setCurrentPage } =
    usePenetapanPredikatTableStore((state) => ({
      filteredItems: state.filteredItems,
      pageSize: state.pageSize,
      currentPage: state.currentPage,
      setCurrentPage: state.setCurrentPage,
    }))

  const handlePageChange = (page: number) => {
    // Update store
    setCurrentPage(page)

    // Update URL
    const query = {
      ...router.query,
      [paramKey]: page.toString(),
    }

    router.replace(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <KinerjaPagination
      totalItems={filteredItems.length}
      pageSize={pageSize}
      currentPage={currentPage}
      onPageChange={handlePageChange}
      className={className}
      itemLabel={itemLabel}
    />
  )
}
